import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragPrioListStatus: 'idle',
    loadAuftragPrioListError: undefined as any,
    loadAuftragPrioListLastArgs: undefined as any,
    loadAuftragPrioStatus: 'idle',
    loadAuftragPrioError: undefined as any,
    saveAuftragPrioStatus: 'idle',
    saveAuftragPrioError: undefined as any,
    deleteAuftragPrioStatus: 'idle',
    deleteAuftragPrioError: undefined as any,

    auftragPrioList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragPrioList = createAsyncThunk('auftragPrioSlice/loadAuftragPrioList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragPrioSlice.loadAuftragPrioListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftprio/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragPrioListStatus } = getState().auftragPrioSlice
        return loadAuftragPrioListStatus !== 'pending'
    }
})

export const loadAuftragPrio = createAsyncThunk('auftragPrioSlice/loadAuftragPrio', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftprio/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragPrioStatus } = getState().auftragPrioSlice
        return loadAuftragPrioStatus !== 'pending'
    }
})

export const saveAuftragPrio = createAsyncThunk('auftragPrioSlice/saveAuftragPrio', async ({ auftragPrio }: any, { rejectWithValue }: any) => {
    let promises = []
    if (auftragPrio?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisauftprio/${ auftragPrio?.HDR_ID }/`,
            prepareData(auftragPrio),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisauftprio/`,
            prepareData(auftragPrio),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAuftragPrioStatus } = getState().auftragPrioSlice
        return saveAuftragPrioStatus !== 'pending'
    }
})

export const deleteAuftragPrio = createAsyncThunk('auftragPrioSlice/deleteAuftragPrio', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisauftprio/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAuftragPrioStatus } = getState().auftragPrioSlice
        return deleteAuftragPrioStatus !== 'pending'
    }
})

const AuftragPrioSlice = createSlice({
    name: 'auftragPrioSlice',
    initialState,
    reducers: {
        resetloadAuftragPrioListError: (state) => {
            state.loadAuftragPrioListError = undefined
        },
        resetloadAuftragPrio: (state) => {
            state.formItem = undefined
            state.loadAuftragPrioError = undefined
        },
        resetloadAuftragPrioError: (state) => {
            state.loadAuftragPrioError = undefined
        },
        resetsaveAuftragPrio: (state) => {
            state.formItem = undefined
            state.saveAuftragPrioError = undefined
        },
        resetsaveAuftragPrioError: (state) => {
            state.saveAuftragPrioError = undefined
        },
        resetdeleteAuftragPrioError: (state) => {
            state.deleteAuftragPrioError = undefined
        },
        removeFromAuftragPrioListById: (state, action) => {
            state.auftragPrioList = state.auftragPrioList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragPrioListByIds: (state, action) => {
            state.auftragPrioList = state.auftragPrioList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragPrioList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragPrioListStatus = 'preloaded'
            state.loadAuftragPrioListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragPrioList = []
            state.loadAuftragPrioListStatus = 'idle'
            state.loadAuftragPrioListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragPrioList.pending, (state) => {
            state.loadAuftragPrioListStatus = 'pending'
            state.loadAuftragPrioListError = undefined
        })
        builder.addCase(loadAuftragPrioList.fulfilled, (state, action) => {
            state.loadAuftragPrioListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragPrioListLastArgs = action.payload.args

            {
                state.auftragPrioList = action.payload.data

            }
        })
        builder.addCase(loadAuftragPrioList.rejected, (state, action) => {
            state.loadAuftragPrioListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragPrioListError = action.error.message
            } else {
                state.loadAuftragPrioListError = action.payload
            }
        })

        builder.addCase(loadAuftragPrio.pending, (state) => {
            state.loadAuftragPrioStatus = 'pending'
            state.loadAuftragPrioError = undefined
        })
        builder.addCase(loadAuftragPrio.fulfilled, (state, action) => {
            state.loadAuftragPrioStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragPrioList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragPrioList.push(newItem) }
                else { state.auftragPrioList[i] = { ...state.auftragPrioList[i], ...newItem } }
            }
        })
        builder.addCase(loadAuftragPrio.rejected, (state, action) => {
            state.loadAuftragPrioStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragPrioError = action.error.message
            } else {
                state.loadAuftragPrioError = action.payload
            }
        })

        builder.addCase(saveAuftragPrio.pending, (state) => {
            state.saveAuftragPrioStatus = 'pending'
            state.saveAuftragPrioError = undefined
        })
        builder.addCase(saveAuftragPrio.fulfilled, (state, action) => {
            state.saveAuftragPrioStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragPrioList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragPrioList.push(newItem) }
                else { state.auftragPrioList[i] = { ...state.auftragPrioList[i], ...newItem } }
            }
        })
        builder.addCase(saveAuftragPrio.rejected, (state, action) => {
            state.saveAuftragPrioStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAuftragPrioError = action.error.message
            } else {
                state.saveAuftragPrioError = action.payload
            }
        })

        builder.addCase(deleteAuftragPrio.pending, (state) => {
            state.deleteAuftragPrioStatus = 'pending'
            state.deleteAuftragPrioError = undefined
        })
        builder.addCase(deleteAuftragPrio.fulfilled, (state, action) => {
            state.deleteAuftragPrioStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.auftragPrioList = state.auftragPrioList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.auftragPrioList = state.auftragPrioList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAuftragPrio.rejected, (state, action) => {
            state.deleteAuftragPrioStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAuftragPrioError = action.error.message
            } else {
                state.deleteAuftragPrioError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragPrioListError,
    resetloadAuftragPrio,
    resetloadAuftragPrioError,
    resetsaveAuftragPrio,
    resetsaveAuftragPrioError,
    resetdeleteAuftragPrioError,
    removeFromAuftragPrioListById,
    removeFromAuftragPrioListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragPrioSlice.actions
export default AuftragPrioSlice.reducer
